import { CustomFolderFileType, Status } from "src/core/constants/folders";
import {
  FolderFileDocument,
  FolderFileQueryVariables,
  FolderFilesCountDocument,
  FolderFilesCountQueryVariables,
} from "src/core/gql/graphql";

const defaultFolderFilesCountVars: FolderFilesCountQueryVariables = {
  draftState: [Status.DRAFT],
  validationPendingState: [Status.VALIDATION_PENDING],
  validationPendingHrState: [Status.VALIDATION_PENDING_HR],
  missionCreation: [
    CustomFolderFileType.MISSION_CREATION,
    CustomFolderFileType.MISSION_CREATION_PPH,
    CustomFolderFileType.MISSION_RENEWAL,
    CustomFolderFileType.MISSION_RENEWAL_PPH,
  ],
  validatedState: [Status.VALIDATED],
};

/**
 * @description Retourne la requête pour le refetch des compteurs des dossiers (TODO's).
 */
export const buildFolderFilesCountRefetch = () => {
  const variables: FolderFilesCountQueryVariables = {
    ...defaultFolderFilesCountVars,
  };
  return [{ query: FolderFilesCountDocument, variables }];
};

/**
 * @description Retourne la requête pour le refetch du dossier courant.
 * @param folderFileId - L'ID du dossier à refetch
 */
export const buildFolderFileRefetch = (folderFileId: string) => {
  const variables: FolderFileQueryVariables = {
    id: folderFileId,
  };
  return [{ query: FolderFileDocument, variables }];
};
